// Shared helpers and constants for Rental Desk pages.

export const UNIT_STATUS_LABELS = {
  owner_interested: "Owner interested",
  owner_onboarded: "Owner onboarded",
  unit_verified: "Verified",
  listed: "Listed",
  tenant_visits_scheduled: "Visits scheduled",
  tenant_shortlisted: "Shortlisted",
  lease_negotiation: "Negotiation",
  agreement_in_progress: "Agreement",
  rented_active: "Rented (active)",
  renewal_due: "Renewal due",
  notice_period: "Notice period",
  vacant_relist: "Vacant / relist",
};

export const TENANT_STAGE_LABELS = {
  new: "New",
  contacted: "Contacted",
  qualified: "Qualified",
  visit_scheduled: "Visit scheduled",
  visit_done: "Visit done",
  shortlisted_unit: "Shortlisted",
  negotiation: "Negotiation",
  documents_pending: "Documents pending",
  agreement_done: "Agreement done",
  moved_in: "Moved in",
  lost: "Lost",
};

export const LEASE_STATUS_LABELS = {
  draft: "Draft",
  documents_pending: "Documents pending",
  owner_approval_pending: "Owner approval",
  tenant_approval_pending: "Tenant approval",
  agreement_signed: "Agreement signed",
  active: "Active",
  renewal_due: "Renewal due",
  notice_received: "Notice received",
  closed: "Closed",
};

export const SERVICE_STATUS_LABELS = {
  new: "New",
  assigned: "Assigned",
  owner_approval_needed: "Owner approval",
  in_progress: "In progress",
  resolved: "Resolved",
  closed: "Closed",
  escalated: "Escalated",
};

export const UNIT_STATUS_COLORS = {
  listed: "bg-emerald-100 text-emerald-700",
  rented_active: "bg-blue-100 text-blue-700",
  renewal_due: "bg-amber-100 text-amber-700",
  notice_period: "bg-orange-100 text-orange-700",
  vacant_relist: "bg-rose-100 text-rose-700",
  owner_interested: "bg-slate-100 text-slate-700",
  owner_onboarded: "bg-slate-100 text-slate-700",
  unit_verified: "bg-indigo-100 text-indigo-700",
  tenant_visits_scheduled: "bg-violet-100 text-violet-700",
  tenant_shortlisted: "bg-violet-100 text-violet-700",
  lease_negotiation: "bg-yellow-100 text-yellow-700",
  agreement_in_progress: "bg-yellow-100 text-yellow-700",
};

export const TENANT_STAGE_COLORS = {
  new: "bg-slate-100 text-slate-700",
  contacted: "bg-blue-100 text-blue-700",
  qualified: "bg-indigo-100 text-indigo-700",
  visit_scheduled: "bg-violet-100 text-violet-700",
  visit_done: "bg-violet-100 text-violet-700",
  shortlisted_unit: "bg-amber-100 text-amber-700",
  negotiation: "bg-yellow-100 text-yellow-700",
  documents_pending: "bg-yellow-100 text-yellow-700",
  agreement_done: "bg-emerald-100 text-emerald-700",
  moved_in: "bg-emerald-100 text-emerald-700",
  lost: "bg-rose-100 text-rose-700",
};

export const LEASE_STATUS_COLORS = {
  active: "bg-emerald-100 text-emerald-700",
  renewal_due: "bg-amber-100 text-amber-700",
  notice_received: "bg-orange-100 text-orange-700",
  closed: "bg-slate-100 text-slate-600",
  draft: "bg-slate-100 text-slate-700",
  documents_pending: "bg-yellow-100 text-yellow-700",
  owner_approval_pending: "bg-yellow-100 text-yellow-700",
  tenant_approval_pending: "bg-yellow-100 text-yellow-700",
  agreement_signed: "bg-blue-100 text-blue-700",
};

export const SERVICE_STATUS_COLORS = {
  new: "bg-blue-100 text-blue-700",
  assigned: "bg-indigo-100 text-indigo-700",
  owner_approval_needed: "bg-amber-100 text-amber-700",
  in_progress: "bg-violet-100 text-violet-700",
  resolved: "bg-emerald-100 text-emerald-700",
  closed: "bg-slate-100 text-slate-600",
  escalated: "bg-rose-100 text-rose-700",
};

export const PRIORITY_COLORS = {
  urgent: "bg-rose-100 text-rose-700",
  high: "bg-orange-100 text-orange-700",
  normal: "bg-slate-100 text-slate-700",
  low: "bg-slate-100 text-slate-500",
};

export const formatINR = (n) => {
  if (n == null || n === "" || isNaN(Number(n))) return "—";
  const num = Number(n);
  if (num >= 10000000) return `₹${(num / 10000000).toFixed(2)} Cr`;
  if (num >= 100000) return `₹${(num / 100000).toFixed(2)} L`;
  if (num >= 1000) return `₹${(num / 1000).toFixed(1)}K`;
  return `₹${num.toLocaleString("en-IN")}`;
};

export const fmtDate = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("en-IN", {
      day: "2-digit", month: "short", year: "numeric",
    });
  } catch {
    return iso;
  }
};

export const fmtDateTime = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("en-IN", {
      day: "2-digit", month: "short", year: "numeric",
      hour: "2-digit", minute: "2-digit",
    });
  } catch {
    return iso;
  }
};

export const labelOf = (map, key) => map[key] || (key || "—").replace(/_/g, " ");
